// для флага isLayoutApproved
export default [
  {
    text: 'Узаконена',
    value: true,
  },
  {
    text: 'Не узаконена',
    value: false,
  },
];
